import createHostComponent from '../../createHostComponent';
import defaults from './props/default';
var View = createHostComponent('view', null, defaults);
export default View;
